"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMetricToBackend = void 0;
var tslib_1 = require("tslib");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
function convertMetricToBackend(measure) {
    return {
        meta: tslib_1.__assign(tslib_1.__assign({}, (sdk_backend_spi_1.isMeasureMetadataObject(measure) && {
            identifier: measure.id,
            uri: measure.uri,
        })), { title: measure.title || "", summary: measure.description, locked: measure.isLocked }),
        content: {
            expression: measure.expression,
            format: measure.format,
        },
    };
}
exports.convertMetricToBackend = convertMetricToBackend;
//# sourceMappingURL=MetricConverter.js.map